"use client";

import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pl";
import { resolvePluralsMinutes } from "@/service/text/plurals";
import { cn } from "@/lib/utils";
import { scrollToPos } from "@/service/scroll/scroll"; // Import Polish locale

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale("pl"); // Set locale to Polish

function secondsToHHMMSS(seconds: number) {
  const dur = dayjs.duration(seconds, "seconds");
  return dur.format("HH:mm:ss");
}

function nowPlusXSeconds(seconds: number) {
  return resolvePluralsMinutes(Math.round(seconds / 60));
}

export const VideoChapters = ({ chapters }: { chapters: VideoChapterVM[] }) => {
  if (!chapters || chapters.length === 0) {
    return null;
  }
  return (
    <div>
      <h2 className={`mt-8 mb-4 text-lg font-semibold text-zinc-950`}>
        Rozdziały wideo
      </h2>
      <div className={"flex flex-col gap-6"}>
        {chapters.map((chapter) => (
          <Chapter key={chapter.title} chapter={chapter} />
        ))}
      </div>
    </div>
  );
};

const Chapter = ({ chapter }: { chapter: VideoChapterVM }) => {
  const { image, title, duration, timestamp } = chapter;
  return (
    <div
      className={
        "group flex items-center gap-6 select-none hover:cursor-pointer"
      }
      onClick={() => {
        const event = new CustomEvent("update-timestamp", {
          detail: {
            timestamp,
          },
        });
        dispatchEvent(event);
        scrollToPos({ top: 0 });
      }}
    >
      <div
        className={cn(
          "outline-remedium-blue/5 overflow-hidden rounded-xl outline",
          "w-[150px] min-w-[150px]",
        )}
      >
        <PictureUpload className={"w-[150px] min-w-[150px]"} image={image} />
      </div>
      <div>
        <h3
          className={`group-hover:text-remedium-blue mb-0.5 text-sm font-medium transition-all`}
        >
          {title}
        </h3>
        <div className={"flex items-center gap-1"}>
          <div className={`text-remedium-blue text-sm font-medium`}>
            {secondsToHHMMSS(timestamp)}
          </div>
          <div className={`text-muted-foreground text-sm font-normal`}>·</div>
          <div className={`text-muted-foreground text-sm font-normal`}>
            {nowPlusXSeconds(duration)}
          </div>
        </div>
      </div>
    </div>
  );
};
